import type { SVGProps } from 'react';

const SvgVolumeOffFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M11.5459 3.40363C11.7726 3.23106 12.0776 3.20196 12.333 3.32843C12.5883 3.45502 12.75 3.71531 12.75 4.00031V20.0003C12.7499 20.2853 12.5883 20.5456 12.333 20.6722C12.0777 20.7986 11.7726 20.7695 11.5459 20.597L5.74707 16.179H3C2.58589 16.179 2.25017 15.8431 2.25 15.429V8.5716C2.25008 8.15745 2.58583 7.8216 3 7.8216H5.74707L11.5459 3.40363Z'
      fill='currentColor'
    />
    <path
      d='M19.4697 9.46985C19.7626 9.17695 20.2374 9.17695 20.5303 9.46985C20.8232 9.76274 20.8232 10.2375 20.5303 10.5304L19.0605 12.0001L20.5303 13.4698C20.8232 13.7627 20.8232 14.2375 20.5303 14.5304C20.2557 14.805 19.8209 14.8225 19.5264 14.5822L19.4697 14.5304L18 13.0607L16.5303 14.5304C16.2374 14.8233 15.7626 14.8233 15.4697 14.5304C15.1768 14.2375 15.1768 13.7627 15.4697 13.4698L16.9395 12.0001L15.4697 10.5304C15.1768 10.2375 15.1768 9.76274 15.4697 9.46985C15.7626 9.17695 16.2374 9.17695 16.5303 9.46985L18 10.9396L19.4697 9.46985Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgVolumeOffFilled;
